import { either, iots, pipe } from '@code-expert/prelude';
import type { LtiError } from '/imports/domain';
import { LtiErrorC } from '/imports/domain';
import type { QueryValues } from '/imports/modules/Routing';
import { end, formatRoute, lit, query, url } from '/imports/modules/Routing';

const LtiErrorFromQuery: iots.Type<LtiError, Record<string, QueryValues>> = new iots.Type(
  'LtiErrorFromQuery',
  LtiErrorC.is,
  (u, c) =>
    pipe(
      iots.record(iots.string, iots.string).validate(u, c),
      either.chain(({ _tag, ...value }) => LtiErrorC.validate({ _tag, value }, c)),
    ),
  ({ _tag, value }) => ({ _tag, ...value }),
);

export const ltiErrorRoute = url(lit('ltiError'), query(LtiErrorFromQuery), end);

export const ltiErrorLink = formatRoute(ltiErrorRoute);
